import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Eeezo from "../../../assets/Images/eeezo_logo.png";
import List from "../../elements/Lists/Lists";
import Selectbox from "../../elements/SelectBox/SelectBox";
import Profile from "../../../assets/Profile.png";
import Textinput from "../../elements/TextInput/TextInput";
import Button from "../../elements/Button/Button";
import { AuthContext, useAuth } from "../../../context/AuthContext";
import ProjectCreation from "../../ProjectPipeline/ProjectCreation";
import Person from "../../../assets/Images/person.jpg";
import CryptoJS from "crypto-js";
import "../Topbar/Topbar.css";
import Swal from "sweetalert2";
import UsageModal from "./Usage";
// import { profile } from "console";
const Topbar = () => {
  var cid;
  var userName;
  var userEmail;
  var userPhoto;
  var userCompany;
  const { token } = useContext(AuthContext);
  const encryptedMetadata = localStorage.getItem("metadata");
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isCompanyIdset, setiscompanyIdset] = useState(false);
  const notificationRef = useRef(null);
  const [roleID, setRoleID] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  //const [decryptedMetadataAll , setdecryptedMetadataAll] = useState({});

  useEffect(() => {
    const encryptedMetadata = localStorage.getItem("metadata");
    if (encryptedMetadata) {
      try {
        const decryptedMetadata = JSON.parse(
          CryptoJS.AES.decrypt(
            encryptedMetadata,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );
        // console.log(decryptedMetadata);
        //setdecryptedMetadataAll(decryptedMetadata);
        if (decryptedMetadata?.role_id) {
          setRoleID(decryptedMetadata.role_id);
        }
      } catch (error) {
        console.error("Failed to decrypt metadata:", error);
      }
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setIsNotificationOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // console.log(token, "token");
  const fetchNotification = async () => {
    const encryptedMetadata = localStorage.getItem("metadata");
    const decryptedMetadata = JSON.parse(
      CryptoJS.AES.decrypt(
        encryptedMetadata,
        process.env.REACT_APP_SECRETKEY
      ).toString(CryptoJS.enc.Utf8)
    );
    const CID = {
      company_id: decryptedMetadata.cid,
      user_id: decryptedMetadata.uid,
    };
    // console.log(CID);
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(CID),
      process.env.REACT_APP_SECRETKEY
    ).toString();
    const encryptjson = { data: encryptedData };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/notification/fetchNotification`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify(encryptjson),
        }
      );

      const status = await response.json();
      const Notification = JSON.parse(
        CryptoJS.AES.decrypt(
          status.data,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      // console.log("Notification", Notification);
      const NotificationData = Notification.map((notifdata) => {
        const timeDifference = calculateTimeDifference(notifdata.created_at);
        return {
          text: notifdata.info,
          id: notifdata.ref_id,
          time: timeDifference,
          type: notifdata.type,
        };
      });
      setNotifications(NotificationData);
      // console.log("NotificationData", NotificationData);
    } catch (err) {
      console.error("Error Fetching Job List:", err);
    }
  };
  const approvJobFun = (job_id_Get, type) => {
    navigate("/JobApprove", { state: { job_id_Get, type } });
  };
  const calculateTimeDifference = (createdAt) => {
    const createdTime = new Date(createdAt);
    const currentTime = new Date();

    const diffInSeconds = Math.floor((currentTime - createdTime) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds}s`;
    } else if (diffInSeconds < 3600) {
      const diffInMinutes = Math.floor(diffInSeconds / 60);
      return `${diffInMinutes}m`;
    } else if (diffInSeconds < 86400) {
      const diffInHours = Math.floor(diffInSeconds / 3600);
      return `${diffInHours}h`;
    } else {
      const diffInDays = Math.floor(diffInSeconds / 86400);
      return `${diffInDays}d`;
    }
  };
  const handleNotification = async () => {
    const notification = await fetchNotification();
    setIsNotificationOpen(!isNotificationOpen);
  };
  // console.log(encryptedMetadata,"encryptedMetadatai ")
  if (encryptedMetadata) {
    // && encryptedMetadata.data) {
    // console.log(encryptedMetadata,"encryptedMetadata")
    const decryptedMetadata = JSON.parse(
      CryptoJS.AES.decrypt(
        encryptedMetadata,
        process.env.REACT_APP_SECRETKEY
      ).toString(CryptoJS.enc.Utf8)
    );
    cid = decryptedMetadata.cid;
    userName = decryptedMetadata.name;
    userEmail = decryptedMetadata.email;
    if (
      decryptedMetadata.profile &&
      decryptedMetadata.profile.startsWith("http")
    ) {
      userPhoto = decryptedMetadata.profile;
    } else {
      userPhoto = `${process.env.REACT_APP_SERVER_BASEURL}/profile/${decryptedMetadata.profile}`;
    }
    if (decryptedMetadata.company_name)
      userCompany = decryptedMetadata.company_name;
    // console.log(userPhoto, "userPhoto");
    // console.log(decryptedMetadata, "decryptedMetadata");
  }
  const loadProfile = async () => {
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/company/fetchCompanyUsers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      });
      const data = await response.json();

      const decryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          data.data,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      // console.log("following:", decryptedData);
      // if (!response.ok) {
      //     var errorMessage = "Something Went Wrong";
      //     if(data.error)
      //         errorMessage = data.error;
      //     showNotification(errorMessage,"error");
      //     throw new Error(data.error);
      // }
      // else{
      //     userName.current.value=decryptedData[0]['name'];
      //     userEmail.current.value=decryptedData[0]['email'];
      //     userPhoneNo.current.value=decryptedData[0]['phone_no'];
      //     set_Phone(decryptedData[0]['phone_no']);
      //     if(decryptedData[0]['notification'] && decryptedData[0]['notification'] == "true"){
      //       userCheckNotification.current.checked=true;
      //     }
      // }
    } catch (error) {
      console.log("Error:", error);
      let errorMessage = "Something went wrong.";
      if (error.response && error.response.data && error.response.data.msg) {
        errorMessage = error.response.data.msg;
      } else if (error.message) {
        errorMessage = error.message;
      }
      // showNotification(errorMessage, "error");
    }
  };
  useEffect(() => {
    // loadProfile();
  }, []);

  // const { token } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [IsCrPrModalOpen, setIsCrPrModalOpen] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();
  const profile_navbar_dropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleJobNavigation = () => {
    navigate("/JobListing");
  };
  const handleProjectNavigation = () => {
    navigate("/calendar");
  };
  const handleAdminPricing = () => {
    navigate("/Adminpricing");
  };
  const handleResumeNavigation = () => {
    navigate("/Resume");
  };
  const handleTriageNavigation = () => {
    navigate("/Triage");
  };

  const goToManageWorkSpace = () => {
    navigate("/ManageWorkspace");
  };

  const [OrganizationSelect, setIndustryValue] = useState("");
  const { handleLogout } = useContext(AuthContext);
  const handleOrganizationChange = (event) => {
    setIndustryValue(event.target.value);
  };
  const Organization = [
    { id: "0", label: "Organization" },
    { id: "1", label: "Small (1-10 employees)" },
    { id: "2", label: "Medium (11-50 employees)" },
  ];

  const [isWorkspaceSubmenuOpen, setIsWorkspaceSubmenuOpen] = useState(false); // State to toggle the visibility of the submenu

  const [workspaces, setWorkspaces] = useState([]);

  const handleSubmenuToggle = () => {
    // Toggle the workspace submenu
    setIsWorkspaceSubmenuOpen(!isWorkspaceSubmenuOpen);

    // If the submenu is opening, increase the parent div height
    if (!isWorkspaceSubmenuOpen) {
      loadWorkspace();
    }
  };

  const handleWorkspaceClick = (workspace) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the workspace?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      cancelButtonText: "No, cancel!",
    }).then(async (swalResult) => {
      if (swalResult.isConfirmed) {
        const { workspace_id, email, company_id, name } = workspace;

        const workspaceData = { workspace_id, email };

        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(workspaceData),
          process.env.REACT_APP_SECRETKEY
        ).toString();

        const requestData = { data: encryptedData };

        try {
          const serverURL = process.env.REACT_APP_SERVER_URL;
          const response = await fetch(
            `${serverURL}/company/updateActiveWorkspace`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                token: token,
              },
              body: JSON.stringify(requestData),
            }
          );

          if (!response.ok) {
            throw new Error("Failed to update workspace");
          }

          const result = await response.json();

          const decryptedData = JSON.parse(
            CryptoJS.AES.decrypt(
              result.data,
              process.env.REACT_APP_SECRETKEY
            ).toString(CryptoJS.enc.Utf8)
          );

          if (decryptedData.message) {
            Swal.fire("Changed!", decryptedData.message, "success").then(() => {
              const encryptedMetadata = localStorage.getItem("metadata");
              if (encryptedMetadata) {
                const decryptedMetadata = JSON.parse(
                  CryptoJS.AES.decrypt(
                    encryptedMetadata,
                    process.env.REACT_APP_SECRETKEY
                  ).toString(CryptoJS.enc.Utf8)
                );

                decryptedMetadata.cid = company_id;
                decryptedMetadata.company_name = name;

                const encryptedCID = CryptoJS.AES.encrypt(
                  JSON.stringify(decryptedMetadata),
                  process.env.REACT_APP_SECRETKEY
                ).toString();

                localStorage.setItem("metadata", encryptedCID);
                navigate("/Dashboard");
              }
            });
          } else {
            Swal.fire(
              "Error!",
              "Something went wrong. Please try again.",
              "error"
            );
          }
        } catch (error) {
          console.log("Error:", error);
          Swal.fire("Error!", "An unexpected error occurred.", "error");
        }
      }
    });
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown and the dropdown is open
    if (
      isOpen &&
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setIsOpen(false);
      setIsWorkspaceSubmenuOpen(false);
    }
  };

  const loadWorkspace = async () => {
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/company/fetchWorkspace`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      });
      const data = await response.json();

      const decryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          data.data,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      if (decryptedData) {
        // console.log("company workspace data", decryptedData);
        setWorkspaces(decryptedData); // Update the state with the fetched workspaces
      }
    } catch (error) {
      console.log("Error:", error);
      let errorMessage = "Something went wrong.";
      if (error.response && error.response.data && error.response.data.msg) {
        errorMessage = error.response.data.msg;
      } else if (error.message) {
        errorMessage = error.message;
      }
    }
  };

  useEffect(() => {
    // Attach the event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const [AlchemySelect, setAlchemyValue] = useState("");

  const handleAlchemyChange = (event) => {
    setAlchemyValue(event.target.value);
  };
  const Alchemy = [
    { id: "0", label: "Alchemy" },
    { id: "1", label: "Small (1-10 employees)" },
    { id: "2", label: "Medium (11-50 employees)" },
  ];

  const handleCreateClick = () => {
    localStorage.removeItem("jobCreationData");
    navigate("/JobDashboard");
  };
  const navigateDash = () => {
    navigate("/Dashboard");
  };
  const navigateMessage = () => {
    navigate("/Message");
  };
  const handlePricing = () => {
    navigate("/pricing");
  };
  const [showUsageModal, setShowUsageModal] = useState(false);
  const handleUsageModal = () => {
    setIsOpen(false);
    setShowUsageModal(!showUsageModal);
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const [usageData, setUsageData] = useState({});
  const [alertType, setAlertType] = useState(false);
  const [onlyFirstCheck, setOnlyFirstCheck] = useState(false);
  const [usageAlerts, setUsageAlerts] = useState([]);
  const [usageWarnings, setUsageWarnings] = useState([]);
  const [expireStatus, setExpireStatus] = useState(false);
  const [expireDiff, setExpireDiff] = useState(0);

  useEffect(() => {
    const fetchUsage = async () => {
      try {
        const serverURL = process.env.REACT_APP_SERVER_URL;
        const response = await fetch(`${serverURL}/subscription/getUsage`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        });
        const data = await response.json();
        const decryptedData = JSON.parse(
          CryptoJS.AES.decrypt(
            data.data,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );
        console.log("Usage Data", decryptedData);
        setUsageData(decryptedData);
        const encryptedMetadataAll = localStorage.getItem("metadata");
        const decryptedMetadataAll = JSON.parse(
          CryptoJS.AES.decrypt(
            encryptedMetadataAll,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );
        // console.log(decryptedMetadataAll,"decryptedMetadataAll")
        // console.log(data.alertType,data.expireStatus,"data.alertType ||data.expireStatus")
        if (decryptedMetadataAll) {
          if (
            data &&
            (data.alertType || data.expireStatus) &&
            window.location.pathname != "/pricing"
          ) {
            setAlertType(data.alertType);
            setShowUsageModal(true);
            setOnlyFirstCheck(true);
            if (data && data.alerts) setUsageAlerts(data.alerts);
            if (data && data.warnings) setUsageWarnings(data.warnings);
            if (data && data.expireStatus) {
              setExpireStatus(data.expireStatus);
              if (data && data.expireStatus === "expiring") {
                const end_date = new Date(data.endDate);
                const current_date = new Date();
                const diffMs = end_date - current_date;
                const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                setExpireDiff(diffDays);
                console.log(`Expire within : ${diffDays} days`);
              }
              if (data && data.expireStatus === "expired") {
                const end_date = new Date(data.endDate);
                const current_date = new Date();
                const diffMs = current_date - end_date;
                const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                setExpireDiff(diffDays);
                console.log(`Expired within : ${diffDays} days`);
              }
            }
            decryptedMetadataAll["alert"] = true;
            const updatedMetadata = CryptoJS.AES.encrypt(
              JSON.stringify(decryptedMetadataAll),
              process.env.REACT_APP_SECRETKEY
            ).toString();
            localStorage.setItem("metadata", updatedMetadata);
          }
        }
      } catch (error) {
        console.error("Error Fetching Usage Data:", error);
      }
    };
    fetchUsage();
  }, []);
  const isActive = (path) => window.location.pathname === path;
  return (
    <div className="bg-white border-b border-gray-200">
      {/* Main Topbar */}
      <div className="flex items-center justify-between px-4 py-2">
        <UsageModal
          datediff={expireDiff}
          isOpen={showUsageModal}
          onClose={handleUsageModal}
          data={usageData}
          alertType={alertType}
          expireStatus={expireStatus}
        />

        {/* Logo */}
        <div
          onClick={navigateDash}
          className="cursor-pointer py-2 flex-shrink-0"
        >
          <img src={Eeezo} className="w-28 sm:w-32 lg:w-36 h-auto" />
        </div>

        {/* Desktop Navigation - Hidden on mobile */}
        <div className="hidden lg:flex items-center space-x-6 flex-1 justify-center">
          {IsCrPrModalOpen && (
            <ProjectCreation onClose={() => setIsCrPrModalOpen(false)} />
          )}

          {roleID !== 99 && (
            <List
              ulClass="navbar_content flex items-center space-x-6 mb-0"
              lists={
                <>
                  <li
                    className={`list-none cursor-pointer ${
                      isActive("/JobListing") ? "active-tab" : ""
                    }`}
                  >
                    <p
                      className="mb-0 hover:text-green-600 transition-colors"
                      onClick={handleJobNavigation}
                    >
                      Jobs
                    </p>
                  </li>
                  <li
                    className={`list-none cursor-pointer ${
                      isActive("/calendar") ? "active-tab" : ""
                    }`}
                    onClick={handleProjectNavigation}
                  >
                    <p className="mb-0 hover:text-green-600 transition-colors">
                      Schedule
                    </p>
                  </li>
                  <li
                    className={`list-none cursor-pointer ${
                      isActive("/Resume") || isActive("/ResumeMatch")
                        ? "active-tab"
                        : ""
                    }`}
                    onClick={handleResumeNavigation}
                  >
                    <p className="mb-0 hover:text-green-600 transition-colors">
                      Resume Box
                    </p>
                  </li>
                  <li
                    className={`list-none cursor-pointer ${
                      isActive("/Triage") ? "active-tab" : ""
                    }`}
                    onClick={handleTriageNavigation}
                  >
                    <p className="mb-0 hover:text-green-600 transition-colors">
                      InboxGenie
                    </p>
                  </li>
                </>
              }
            />
          )}

          {roleID === 99 && (
            <List
              ulClass="navbar_content flex items-center space-x-6 mb-0"
              lists={
                <>
                  <li
                    className={`list-none cursor-pointer ${
                      isActive("/Adminpricing") ? "active-tab" : ""
                    }`}
                  >
                    <p
                      className="mb-0 hover:text-green-600 transition-colors"
                      onClick={handleAdminPricing}
                    >
                      Pricing
                    </p>
                  </li>
                  <li
                    className={`list-none cursor-pointer ${
                      isActive("/Adminapproval") ? "active-tab" : ""
                    }`}
                    onClick={() => navigate("/Adminapproval")}
                  >
                    <p className="mb-0 hover:text-green-600 transition-colors">
                      Pending Approvals
                    </p>
                  </li>
                  <li
                    className={`list-none cursor-pointer ${
                      isActive("/Adminusage") ? "active-tab" : ""
                    }`}
                    onClick={() => navigate("/Adminusage")}
                  >
                    <p className="mb-0 hover:text-green-600 transition-colors">
                      Usage Stats
                    </p>
                  </li>
                </>
              }
            />
          )}
        </div>

        {/* Right Side Actions */}
        <div className="flex items-center space-x-2 sm:space-x-3">
          {/* Create Button - Hidden on small screens */}
          {roleID !== 99 && (
            <div className="hidden sm:block">
              <Button
                onClick={handleCreateClick}
                className="border-none bg-green-650 text-white rounded-lg px-3 py-2 text-sm lg:px-4 lg:py-2.5 lg:text-base"
              >
                Create +
              </Button>
            </div>
          )}

          {/* Mobile Menu Button - Visible only on mobile/tablet */}
          <button
            onClick={handleMobileMenuToggle}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center space-x-3">
            {/* Notification Button */}
            {roleID !== 99 && (
              <div className="relative">
                <Button
                  type="button"
                  onClick={() => handleNotification()}
                  className="!bg-gray-100 px-2 py-2 rounded-md border border-gray-300 shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <img src="/image/notification.png" className="w-5" />
                </Button>
                {isNotificationOpen && (
                  <div
                    ref={notificationRef}
                    className="no-scrollbar absolute right-0 mt-2 w-80 lg:w-96 shadow-lg border border-gray-200 rounded-lg z-50 bg-gray-50"
                  >
                    <div className="no-scrollbar px-3 py-3 max-h-96 overflow-y-auto">
                      {notifications && notifications.length > 0 ? (
                        notifications.map((notification, index) => (
                          <div
                            onClick={() =>
                              approvJobFun(notification.id, notification.type)
                            }
                            key={index}
                            className="mb-3 flex justify-between items-center p-4 hover:bg-gray-50 border-b last:border-none bg-white rounded-2xl shadow-sm cursor-pointer"
                          >
                            <span
                              className="text-gray-600 text-sm truncate max-w-[80%]"
                              title={notification.text}
                            >
                              {notification.text}
                            </span>
                            <span className="text-gray-400 text-xs ml-2">
                              {notification.time}
                            </span>
                          </div>
                        ))
                      ) : (
                        <div className="p-4 text-gray-500 text-sm">
                          No notifications
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Message Button */}
            {roleID !== 99 && (
              <Button
                onClick={navigateMessage}
                type="button"
                className="!bg-gray-100 px-2 py-2 rounded-md border border-gray-300 shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <img src="/image/message.png" className="w-5" />
              </Button>
            )}
          </div>

          {/* Profile Dropdown */}
          <div className="relative inline-block text-left" ref={dropdownRef}>
            <Button
              type="button"
              onClick={() => setIsOpen(!isOpen)}
              className="!bg-gray-100 px-2 py-2 rounded-md border border-gray-300 shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <img
                src={Profile}
                className={`${roleID === 99 ? "w-8" : "w-5"}`}
                alt="Profile"
              />
            </Button>

            {/* Profile Dropdown Menu - Responsive */}
            {isOpen && (
              <div className="absolute right-0 mt-2 w-80 sm:w-96 lg:w-[435px] rounded-xl shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10 px-6 py-4 lg:px-9 lg:py-5">
                {/* Dropdown arrow */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="129"
                  height="50"
                  className="absolute right-4 lg:right-12 -top-6"
                  viewBox="0 0 129 116"
                  fill="none"
                >
                  <g filter="url(#filter0_d_1246_7829)">
                    <path
                      d="M63.6256 36.375C64.0142 35.875 64.9858 35.875 65.3744 36.375L82.8632 58.875C83.2519 59.375 82.7661 60 81.9888 60H47.0112C46.2339 60 45.7481 59.375 46.1368 58.875L63.6256 36.375Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_1246_7829"
                      x="0"
                      y="0"
                      width="129"
                      height="116"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="10" />
                      <feGaussianBlur stdDeviation="23" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.74902 0 0 0 0 0.878431 0 0 0 0 0.886275 0 0 0 0.4 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1246_7829"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1246_7829"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>

                {/* Profile Section */}
                <div className="border-b-2 pb-4">
                  <div className="flex items-start space-x-4">
                    <img
                      src={userPhoto}
                      className="w-16 h-16 lg:w-20 lg:h-20 rounded-full object-cover flex-shrink-0"
                    />
                    <div className="flex-1 min-w-0">
                      <p className="text-lg lg:text-xl font-medium mb-1 truncate">
                        {userName}
                      </p>
                      <p className="text-sm text-gray-600 mb-1 truncate">
                        {userEmail}
                      </p>
                      {roleID !== 99 && (
                        <p
                          className="text-sm text-green-600 cursor-pointer hover:text-green-700"
                          onClick={() => navigate("/Usersettings")}
                        >
                          Manage Profile
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Menu Items */}
                <div className="mt-4 space-y-2">
                  {roleID !== 99 && (
                    <>
                      <button
                        onClick={handleSubmenuToggle}
                        className="hover-menu font-medium rounded-lg text-base w-full text-left flex items-center justify-between"
                      >
                        Workspace
                      </button>

                      {isWorkspaceSubmenuOpen && (
                        <div className="ml-4 space-y-1">
                          {workspaces.length > 0 ? (
                            workspaces.map((workspace) => {
                              if (workspace.status === "active") {
                                return (
                                  <div
                                    key={workspace.workspace_id}
                                    className="flex justify-between items-center hover:bg-gray-100 cursor-pointer py-2 px-2 rounded"
                                    onClick={() =>
                                      handleWorkspaceClick(workspace)
                                    }
                                  >
                                    <span className="font-medium text-base flex-1 truncate">
                                      {workspace.name}
                                    </span>
                                    {workspace.company_id === cid && (
                                      <span className="text-green-600 ml-2">
                                        ✔️
                                      </span>
                                    )}
                                  </div>
                                );
                              }
                              return null;
                            })
                          ) : (
                            <div className="py-2 text-center text-gray-500">
                              No workspaces available
                            </div>
                          )}

                          {(roleID === 1 || roleID !== 2) && (
                            <div className="flex justify-end mt-2">
                              <p
                                className="text-green-600 font-medium text-sm cursor-pointer hover:text-green-700"
                                onClick={goToManageWorkSpace}
                              >
                                Manage Workspace
                              </p>
                            </div>
                          )}
                        </div>
                      )}

                      <button
                        onClick={handlePricing}
                        className="hover-menu font-medium rounded-lg text-base w-full text-left"
                      >
                        Pricing
                      </button>

                      <button
                        onClick={handleUsageModal}
                        className="hover-menu font-medium rounded-lg text-base w-full text-left"
                      >
                        Usage
                      </button>
                    </>
                  )}

                  <button
                    className="text-red-600 font-bold text-sm hover:text-red-700 w-full text-left mt-4"
                    onClick={handleLogout}
                  >
                    Sign Out
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="lg:hidden">
          <div className="bg-white border-t border-gray-200 shadow-lg">
            <div className="px-4 py-6 space-y-6">
              {/* Create Button for Mobile */}
              {roleID !== 99 && (
                <div className="pb-4 border-b border-gray-200">
                  <Button
                    onClick={() => {
                      handleCreateClick();
                      setIsMobileMenuOpen(false);
                    }}
                    className="w-full border-none bg-green-650 text-white rounded-lg py-3 text-base font-medium"
                  >
                    Create +
                  </Button>
                </div>
              )}

              {/* Navigation Links */}
              {roleID !== 99 ? (
                <div className="space-y-4">
                  <div
                    className={`cursor-pointer py-2 border-b border-gray-100 ${
                      isActive("/JobListing")
                        ? "text-green-600 font-medium"
                        : "text-gray-700"
                    }`}
                    onClick={() => {
                      handleJobNavigation();
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Jobs
                  </div>
                  <div
                    className={`cursor-pointer py-2 border-b border-gray-100 ${
                      isActive("/calendar")
                        ? "text-green-600 font-medium"
                        : "text-gray-700"
                    }`}
                    onClick={() => {
                      handleProjectNavigation();
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Schedule
                  </div>
                  <div
                    className={`cursor-pointer py-2 border-b border-gray-100 ${
                      isActive("/Resume") || isActive("/ResumeMatch")
                        ? "text-green-600 font-medium"
                        : "text-gray-700"
                    }`}
                    onClick={() => {
                      handleResumeNavigation();
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Resume Box
                  </div>
                  <div
                    className={`cursor-pointer py-2 border-b border-gray-100 ${
                      isActive("/Triage")
                        ? "text-green-600 font-medium"
                        : "text-gray-700"
                    }`}
                    onClick={() => {
                      handleTriageNavigation();
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    InboxGenie
                  </div>
                </div>
              ) : (
                <div className="space-y-4">
                  <div
                    className={`cursor-pointer py-2 border-b border-gray-100 ${
                      isActive("/Adminpricing")
                        ? "text-green-600 font-medium"
                        : "text-gray-700"
                    }`}
                    onClick={() => {
                      handleAdminPricing();
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Pricing
                  </div>
                  <div
                    className={`cursor-pointer py-2 border-b border-gray-100 ${
                      isActive("/Adminapproval")
                        ? "text-green-600 font-medium"
                        : "text-gray-700"
                    }`}
                    onClick={() => {
                      navigate("/Adminapproval");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Pending Approvals
                  </div>
                  <div
                    className={`cursor-pointer py-2 border-b border-gray-100 ${
                      isActive("/Adminusage")
                        ? "text-green-600 font-medium"
                        : "text-gray-700"
                    }`}
                    onClick={() => {
                      navigate("/Adminusage");
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    Usage Stats
                  </div>
                </div>
              )}

              {/* Mobile Actions */}
              {roleID !== 99 && (
                <div className="flex justify-center space-x-6 pt-4 border-t border-gray-200">
                  <button
                    onClick={() => {
                      handleNotification();
                      setIsMobileMenuOpen(false);
                    }}
                    className="flex flex-col items-center space-y-1 text-gray-600 hover:text-gray-800"
                  >
                    <img src="/image/notification.png" className="w-6 h-6" />
                    <span className="text-sm">Notifications</span>
                  </button>
                  <button
                    onClick={() => {
                      navigateMessage();
                      setIsMobileMenuOpen(false);
                    }}
                    className="flex flex-col items-center space-y-1 text-gray-600 hover:text-gray-800"
                  >
                    <img src="/image/message.png" className="w-6 h-6" />
                    <span className="text-sm">Messages</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Topbar;
